import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Card, Button, Modal, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { getSelection } from '../../actions/selectionsActions'
import { getCourseSubjects, getLevels } from '../../actions/miscellaneousActions'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { Link, useParams } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { addVideo, getChoosesByFilter, getInterviewsCalendarByCandidate, sendOfferLetterResolution, setScheduleInterview } from '../../actions/choosesActions'
import Swal from 'sweetalert2'
import SelectionStatus from '../../components/selection/selectionStatus'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction"
import '@fullcalendar/bootstrap5/main.css'
import '@fullcalendar/daygrid/main.css'
import esLocale from '@fullcalendar/core/locales/es'
import InterviewSection from '../../components/jitsi/InterviewSection'
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer'
import OfferLetter from '../../components/pdfs/OfferLetter'
import { getSchoolBySelection } from '../../actions/schoolsActions'

export default function Process() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const params = useParams()
	const {client} = useAuth()
    
    const calendar = useRef(null)

    const {loading, selection} = useSelector(state => state.selections)
    const {levels, subjects} = useSelector(state => state.miscellaneous)
    const {choose, loading: chooseLoading, result, schedule} = useSelector(state => state.chooses)
    const {school} = useSelector(state => state.schools)

    const [addVideoPresentation, setAddVideoPresentation] = useState(false)
    const [video, setVideo] = useState(null)
    const [activeTab, setActiveTab] = useState('initProcess')

    const [selectedInterviewDate, setSelectedInterviewDate] = useState(null)
    const [interviewComment, setInterviewComment] = useState(null)
    const [isMeetingVisible, setIsMeetingVisible] = useState(false); // Controla si la reunión de Jitsi se muestra

    const [selectedEvent, setSelectedEvent] = useState(null)

    const videoFileInput = useRef(null)

    const [offerLetterResolution, setOfferLetterResolution] = useState(null)
    const [offerLetterComment, setOfferLetterComment] = useState(null)

    const capitalizeFirstCharacter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        } else {
            return ''
        }
    }

    const handleAddVideoModalHide = () => {
        setAddVideoPresentation(false)
        setVideo(null)
        videoFileInput.current.value = null
    }

    const handleSaveVideo = () => {
        dispatch(addVideo(choose._id, video))
    }

    const handleSetScheduleInterview = (index) => {
        if ((!selectedInterviewDate || selectedInterviewDate === "null") && (!interviewComment || interviewComment === "")) {
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('selection.errorScheduleForm')
            })
        } else {
            dispatch(setScheduleInterview(choose._id, index, selectedInterviewDate, interviewComment))
        }
    }

    const handleEventClick = (e) => {
        if (e.event._def?.extendedProps?.type !== "choose") {
            setSelectedEvent(e.event._def?.extendedProps)
        }
    }

    

    const handleSetOfferLetterResolution = () => {
        if (offerLetterResolution && (offerLetterResolution === "accept" || (offerLetterResolution === "reject" && offerLetterComment && offerLetterComment !== ""))) {
            dispatch(sendOfferLetterResolution(choose._id, offerLetterResolution, offerLetterComment))
        } else {
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('selection.errorOfferLetterForm')
            })
        }
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(params.id){
            dispatch(getSelection(params.id))
            dispatch(getSchoolBySelection(params.id))
            dispatch(getLevels())
            dispatch(getCourseSubjects())
        }
    },[dispatch, params])

    useEffect(() => {
        if (params?.id && client?.id) {
            dispatch(getChoosesByFilter(params.id, client.id))
            dispatch(getInterviewsCalendarByCandidate(client.id))
        }
    }, [client, params, dispatch])

    useEffect(() => {
        if (result) {
            dispatch({ type: "CHOOSE_RESET_RESULT" })
            
            if (result === "chooseVideoSuccess") {
                Swal.fire({
                    showConfirmButton: true,
                    showDenyButton: false,
                    confirmButtonText: t('global.great'),
                    icon: 'success',
                    text: t('selection.chooseVideoSuccess')
                })
                dispatch(getChoosesByFilter(params.id, client.id))
                setAddVideoPresentation(false)
                setVideo(null)
                videoFileInput.current.value = null
            }
            if (result === "successSetScheduleInterview") {
                Swal.fire({
                    showConfirmButton: true,
                    showDenyButton: false,
                    confirmButtonText: t('global.great'),
                    icon: 'success',
                    text: t('selection.successSetScheduleInterview')
                })
                dispatch(getChoosesByFilter(params.id, client.id))
                dispatch(getInterviewsCalendarByCandidate(client.id))
                setSelectedInterviewDate(null)
                setInterviewComment(null)
            }
            if (result === "successSetOfferLetterResolution") {
                Swal.fire({
                    showConfirmButton: true,
                    showDenyButton: false,
                    confirmButtonText: t('global.great'),
                    icon: 'success',
                    text: t('selection.successSetOfferLetterResolution')
                })
                dispatch(getChoosesByFilter(params.id, client.id))
                setOfferLetterComment(null)
                setOfferLetterResolution(null)
            }
        }
    }, [result, params, client, dispatch, t])
    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-5'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/config.svg" alt="Procesos" />
                        <h1 className='ms-2 m-0'>{t('menus.candidateProcesses')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-3'>
                                <Row className='my-3'>
                                    <Col xs={12} md={9}>
                                        <Link to="/candidate/active-processes" className='text-decoration-none text-general'>
                                            <div className='py-3 d-flex align-items-center'>
                                                <img src="/images/left-arrow.svg" alt="Flecha izquierda" />
                                                <h3 className='ms-3 m-0'>{selection?.title}</h3>
                                            </div>
                                        </Link>
                                    </Col>
                                </Row>
                                {
                                    loading || chooseLoading
                                    ?
                                        <span className="indicator-label">
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    :
                                        <>
                                            {
                                                selection?.profileDescription &&
                                                <div className='my-3'>
                                                    {selection?.profileDescription.split("\n").map((str, strIndex) => (
                                                        <Fragment key={strIndex}>
                                                            {str}
                                                            {
                                                                selection?.profileDescription.split("\n").length > parseInt(strIndex) + 1
                                                                ?
                                                                    <br/>
                                                                :
                                                                    <></>
                                                            }
                                                        </Fragment>
                                                    ))}
                                                    <hr/>
                                                </div>
                                            }
                                            <div className='my-3'>
                                                <h5 className='fw-bold'>{t("selection.status")}</h5>
                                                {choose && choose?.candidateStatus === 1 && (
                                                    <SelectionStatus
                                                        choose={choose}
                                                        selection={selection}
                                                        onTabClick={activeTab => setActiveTab(activeTab)} 
                                                    />
                                                )}
                                                <hr/>
                                            </div>
                                            {
                                                (activeTab === "initProcess" && (choose?.candidateStatus !== 2 || choose?.dimiss)) &&
                                                <div className='my-3'>
                                                    <h5 className='fw-bold'>{t("selection.submenu.generalData")}</h5>
                                                    <Container className='cuadro-datos-generales'>
                                                        {selection?.school?.name &&
                                                            <>
                                                                <Row>
                                                                    <Col xs={6} className='py-2 pe-5'>
                                                                        <div className='d-flex justify-content-between'>
                                                                            {t("users.name")}
                                                                            <small>
                                                                            {selection?.school?.name}
                                                                            {
                                                                                <small>selection?.school?.web</small>
                                                                                ?
                                                                                    <a href={selection?.school?.web} className='link' target="_blank" rel="noopener noreferrer">
                                                                                        <i className='fas fa-globe ps-2'></i>
                                                                                    </a>
                                                                                :
                                                                                    <></>
                                                                            }
                                                                            </small>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={6} className='py-2 ps-5'>
                                                                        <div className='d-flex justify-content-between'>
                                                                            {t("users.address")}
                                                                            <small>{selection?.school?.address}</small>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        }
                                                        <Row>
                                                            <Col xs={6} className='py-2 pe-5'>
                                                                <div className='d-flex justify-content-between'>
                                                                    {t("selection.specialty")}
                                                                    <small>{capitalizeFirstCharacter(levels?.find(l => l.id === selection?.specialty)?.label)}</small>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} className='py-2 ps-5'>
                                                                <div className='d-flex justify-content-between'>
                                                                    {t(selection?.specialty == 1 ? "profile.candidate.position" : "selection.subject")}
                                                                    <small>{t("subjects." + subjects?.find(s => s.id === selection?.subject)?.label)}</small>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={6} className='py-2 pe-5'>
                                                                <div className='d-flex justify-content-between'>
                                                                    {t("selection.shortIncorporationDate")}
                                                                    <small>{`${String(new Date(selection?.incorporationDate).getDate()).padStart(2, '0')}/${String(new Date(selection?.incorporationDate).getMonth() + 1).padStart(2, '0')}/${new Date(selection?.incorporationDate).getFullYear()}`}</small>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} className='py-2 ps-5'>
                                                                <div className='d-flex justify-content-between'>
                                                                    {t("selection.salary")}
                                                                    <small>{selection?.salary || t("selection.byAgreement")}</small>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={6} className='py-2 pe-5'>
                                                                <div className='d-flex justify-content-between'>
                                                                    {t("selection.contractType")}
                                                                    <small>
                                                                        {
                                                                            selection?.fixedDiscontinuous
                                                                            ?
                                                                                t('selection.fixedDiscontinuous')
                                                                            :
                                                                                t('profile.candidate.'+selection?.contractType)
                                                                        }
                                                                    </small>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} className='py-2 ps-5'>
                                                                <div className='d-flex justify-content-between'>
                                                                    {t("profile.candidate.idealPosition.workDay.label")}
                                                                    <small>{t("profile.candidate.idealPosition.workDay." + selection?.workdayType)}</small>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={6} className='py-2 pe-5'>
                                                                <div className='d-flex justify-content-between'>
                                                                    {t("users.town")}
                                                                    <small>{towns?.find(p => p.value === selection?.school?.town)?.label}</small>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} className='py-2 ps-5'>
                                                                <div className='d-flex justify-content-between'>
                                                                    {t("users.province")}
                                                                    <small>{provinces?.find(p => p.value === selection?.school?.province)?.label}</small>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={6} className='py-2 pe-5'>
                                                                <div className='d-flex justify-content-between'>
                                                                    {t("selection.schoolType")}
                                                                    <small>{t("school.typeschool." + selection?.school?.typeschool)}</small>
                                                                </div>
                                                            </Col>
                                                            {
                                                                selection?.distance !== null &&
                                                                <Col xs={6} className='py-2 ps-5'>
                                                                    <div className='d-flex justify-content-between'>
                                                                        {t("selection.distance")}
                                                                        <small>{selection?.distance !== 0 && selection?.distance !== "0" ? `${Math.trunc(Number(selection?.distance))} km` : t("selection.zeroDistance")}</small>
                                                                    </div>
                                                                </Col>
                                                            }
                                                        </Row>
                                                        {selection?.school?.biography &&
                                                            <Row className='py-3'>
                                                                <Col xs={12} className='d-flex justify-content-between'>
                                                                    <div className='title'>
                                                                        <strong>{t("users.biographyschool")}</strong><br/>
                                                                        <div dangerouslySetInnerHTML={{ __html: selection?.school?.biography }} />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        }
                                                    </Container>
                                                </div>
                                            }
                                            {
                                                activeTab === "uploadVideo" && choose?.candidateStatus !== 2 && !choose?.dimiss &&
                                                <>
                                                    <div className='my-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <h5 className='fw-bold'>{t("selection.uploadVideo")}</h5>
                                                            {
                                                                !choose?.videoSaw &&
                                                                <Button variant='primary' type='button' className='py-1' onClick={() => setAddVideoPresentation(true)}>
                                                                    {t('selection.addVideo')}
                                                                    <img src='/images/plus-white.svg' alt='Más' className='ms-2'/>
                                                                </Button>
                                                            }
                                                        </div>
                                                        <hr/>
                                                    </div>
                                                    {
                                                        choose?.videoPresentation
                                                        ?
                                                            <div className='my-3'>
                                                                <div className='bg-grey p-5 d-flex justify-content-between'>
                                                                    <div className='me-3'><i className='fas fa-video fa-3x' /></div>
                                                                    <a href={choose?.videoPresentation} download target="_blank" rel="noreferrer"><i className='fas fa-download'/></a>
                                                                </div>
                                                            </div>
                                                        :
                                                            <div className='my-3 bg-grey text-center rounded py-5'>
                                                                <div>
                                                                    <img src='/images/no-video.svg' alt='No hay vídeo' className='mb-4'/>
                                                                </div>
                                                                <div className='fw-bold'>{t('selection.noVideoTitle')}</div>
                                                                <div className='mb-4'>{t('selection.noVideoDescription')}</div>
                                                                <div>
                                                                    <Button variant='primary' type='button' className='py-1' onClick={() => setAddVideoPresentation(true)}>
                                                                        {t('selection.addVideo')}
                                                                        <img src='/images/plus-white.svg' alt='Más' className='ms-2'/>
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                    }
                                                    <hr/>
                                                </>
                                            }
                                            {
                                                activeTab === "interview" && choose?.candidateStatus !== 2 && !choose?.dimiss &&
                                                <div className='my-5 py-3 bg-grey text-center rounded'>
                                                    {
                                                        choose?.schedule && choose?.schedule?.some(s => s.days?.length > 0)
                                                        ?
                                                            choose.schedule[choose.schedule.length - 1].days.length === 3
                                                            ?
                                                                <>
                                                                    <h5 className='fw-bold mt-4'>
                                                                        {`${t("selection.submenu.interview")}${selection?.interviews && selection?.interviews?.length > 0 ? ` ${choose?.schedule?.length || 1}` : ''}`}
                                                                    </h5>
                                                                    <div className='px-5 mb-3'>
                                                                        <Row>
                                                                            <Col>
                                                                                <Form.Label>{t("selection.chooseInterviewDate")}</Form.Label>
                                                                                {
                                                                                    choose.schedule[choose.schedule.length - 1].days.map((day, dayIndex) => (
                                                                                        <Form.Check
                                                                                            key={dayIndex}
                                                                                            type='radio'
                                                                                            name='scheduleDay'
                                                                                            label={`${String(new Date(day.date).getDate()).padStart(2, '0')}/${String(new Date(day.date).getMonth() + 1).padStart(2, '0')}/${new Date(day.date).getFullYear()} ${day.hour}`}
                                                                                            value={day._id}
                                                                                            onChange={({target}) => setSelectedInterviewDate(target.value)}
                                                                                            checked={selectedInterviewDate === day._id}
                                                                                            className='my-3 d-flex justify-content-center'
                                                                                        />
                                                                                    ))
                                                                                }
                                                                                <Form.Check
                                                                                    type='radio'
                                                                                    name='scheduleDay'
                                                                                    label={t("selection.noInterviewDate")}
                                                                                    value={"null"}
                                                                                    onChange={({target}) => setSelectedInterviewDate(target.value)}
                                                                                    checked={selectedInterviewDate === "null"}
                                                                                    className='my-3 d-flex justify-content-center'
                                                                                />
                                                                                <Form.Check
                                                                                    type='radio'
                                                                                    name='scheduleDay'
                                                                                    label={t("selection.rejectSelection")}
                                                                                    value={"reject"}
                                                                                    onChange={({target}) => setSelectedInterviewDate(target.value)}
                                                                                    checked={selectedInterviewDate === "reject"}
                                                                                    className='my-3 d-flex justify-content-center'
                                                                                />
                                                                                {
                                                                                    (selectedInterviewDate === "null" || selectedInterviewDate === "reject") &&
                                                                                    <Form.Control
                                                                                        as="textarea"
                                                                                        value={interviewComment || ''}
                                                                                        onChange={({target}) => setInterviewComment(target.value)}
                                                                                        required
                                                                                    />
                                                                                }
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className='d-flex justify-content-end my-3'>
                                                                            <Col xs={12} md={4}>
                                                                                <Button type='button' variant='primary' className='mt-3 w-100' onClick={() => handleSetScheduleInterview(choose.schedule.length - 1)}>{t('global.save')}</Button>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className='mt-5 bg-white p-3 rounded'>
                                                                            <Col>
                                                                                {/* <FullCalendar
                                                                                    displayEventTime={false}
                                                                                    ref={calendar}
                                                                                    height={'auto'}
                                                                                    fixedWeekCount={false}
                                                                                    locale={esLocale}
                                                                                    weekends={true}
                                                                                    plugins={[dayGridPlugin, interactionPlugin]}
                                                                                    headerToolbar={{
                                                                                        start: 'prev',
                                                                                        center: 'title',
                                                                                        end: 'next',
                                                                                    }}
                                                                                    events={schedule?.map(s => {
                                                                                        if(s.selection._id === params.id) {
                                                                                            return null
                                                                                        } else {
                                                                                            let eventDate = new Date(s.day)
                                                                                            eventDate.setHours(s.hour.split(':')[0])
                                                                                            eventDate.setMinutes(s.hour.split(':')[1])
                                                                                            return {...s, title: `${s.school?.name || ''} (${s.hour})`, start: eventDate, classNames: ['text-body'], color: s.accepted ? 'green' : 'orange'}
                                                                                        }
                                                                                    })?.filter(s => s !== null)?.concat(choose?.schedule[choose?.schedule?.length - 1]?.days?.map((d, dIndex) => {
                                                                                        let eventDate = new Date(d.date)
                                                                                        eventDate.setHours(d.hour.split(':')[0])
                                                                                        eventDate.setMinutes(d.hour.split(':')[1])
                                                                                        let relatedSchool = schedule?.find(s => s.choose === choose._id)?.school?.name || '';
                                                                                        return {title: `${relatedSchool} (${d.hour})`, start: eventDate, classNames: ['text-body'], type: 'choose'}
                                                                                    }))}
                                                                                    eventClick={handleEventClick}
                                                                                /> */}
                                                                                <FullCalendar
                                                                                    displayEventTime={false}
                                                                                    ref={calendar}
                                                                                    height={'auto'}
                                                                                    fixedWeekCount={false}
                                                                                    locale={esLocale}
                                                                                    weekends={true}
                                                                                    plugins={[dayGridPlugin, interactionPlugin]}
                                                                                    headerToolbar={{
                                                                                        start: 'prev',
                                                                                        center: 'title',
                                                                                        end: 'next',
                                                                                    }}
                                                                                    events={schedule?.map(s => {
                                                                                        if(s.selection._id === params.id) {
                                                                                            return null
                                                                                        } else {
                                                                                            let eventDate = new Date(s.day)
                                                                                            eventDate.setHours(s.hour.split(':')[0])
                                                                                            eventDate.setMinutes(s.hour.split(':')[1])
                                                                                            return {...s, title: `${s.school?.name || ''} (${s.hour})`, start: eventDate, classNames: ['text-body'], color: s.accepted ? 'green' : 'orange'}
                                                                                        }
                                                                                    })?.filter(s => s !== null)?.concat(choose?.schedule.map((s, sIndex) => {
                                                                                        if (sIndex === choose?.schedule.length - 1){
                                                                                            return s.days?.map((d, dIndex) => {
                                                                                                let eventDate = new Date(d.date)
                                                                                                eventDate.setHours(d.hour.split(':')[0])
                                                                                                eventDate.setMinutes(d.hour.split(':')[1])
                                                                                                let relatedSchool = schedule?.find(s => s.choose === choose._id)?.school?.name || '';
                                                                                                return {title: `${relatedSchool} (${d.hour})`, start: eventDate, classNames: ['text-body'], type: 'choose'}
                                                                                            })
                                                                                        } else {
                                                                                            return s.days?.map((d, dIndex) => {
                                                                                                let eventDate = new Date(d.date)
                                                                                                eventDate.setHours(d.hour.split(':')[0])
                                                                                                eventDate.setMinutes(d.hour.split(':')[1])
                                                                                                let relatedSchool = schedule?.find(s => s.choose === choose._id)?.school?.name || '';
                                                                                                return {selection: {...selection}, school: selection?.school, day: d.date, title: `${relatedSchool} (${d.hour})`, start: eventDate, classNames: ['text-body'], color: 'green'}
                                                                                            })
                                                                                        }
                                                                                    })).flat()}
                                                                                    eventClick={handleEventClick}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </>
                                                            :
                                                                choose.schedule[choose.schedule.length - 1].days.length === 1
                                                                ?
                                                                    <>
                                                                        <h5 className='fw-bold mt-4'>
                                                                            {`${t("selection.submenu.interview")}${selection?.interviews && selection?.interviews?.length > 0 ? ` ${choose?.schedule?.length || 1}` : ''}`}
                                                                        </h5>
                                                                        <div className='my-4'>
                                                                            {t('selection.candidateInterviewDate', {
                                                                                date: `${new Date(choose?.schedule[choose?.schedule?.length - 1]?.days[0]?.date).toLocaleDateString('es-ES', {
                                                                                    day: '2-digit',
                                                                                    month: '2-digit',
                                                                                    year: 'numeric',
                                                                                })} ${choose?.schedule[choose?.schedule?.length - 1]?.days[0]?.hour}`,
                                                                            })}
                                                                            <div className='mt-4'>
                                                                                <Button variant='primary' type="button" onClick={() => {setIsMeetingVisible(true)}}>{t("selection.openMeeting")}</Button>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                :
                                                                    <>
                                                                        <img src='/images/wait.svg' alt='success' className='mb-3'/>
                                                                        <h5 className='fw-bold mt-4'>
                                                                            {`${t("selection.submenu.interview")}${selection?.interviews && selection?.interviews?.length > 0 ? ` ${choose?.schedule?.length || 1}` : ''}`}
                                                                        </h5>
                                                                        <div className='my-3'>
                                                                            {t('selection.waitForInterviewSchedule')}
                                                                        </div>
                                                                    </>
                                                        :
                                                            <>
                                                                <img src='/images/wait.svg' alt='success' className='my-3'/>
                                                                <h5 className='fw-bold mt-4'>
                                                                    {`${t("selection.submenu.interview")}${selection?.interviews && selection?.interviews?.length > 0 ? ` ${choose?.schedule?.length || 1}` : ''}`}
                                                                </h5>
                                                                <div className='my-3'>
                                                                    {t('selection.waitForInterviewSchedule')}
                                                                </div>
                                                            </>
                                                    }
                                                </div>
                                            }
                                            {
                                                activeTab === "offerLetter" && choose?.candidateStatus !== 2 && !choose?.dimiss &&
                                                <div className='my-3'>
                                                    <h5 className='fw-bold'>{t("selection.submenu.offerLetter")}</h5>
                                                    {
                                                        choose?.candidateOfferLetterStatus === 0
                                                        ?
                                                            <>
                                                                <div className='my-3'>
                                                                    1. {t("selection.reviewOfferLetter")}
                                                                </div>
                                                                <div style={{height: "70vh"}}>
                                                                    <PDFViewer
                                                                        children={<OfferLetter selection={selection} choose={choose} school={school} />}
                                                                        style={{width: "100%", height: "100%"}}
                                                                    />
                                                                </div>
                                                                <div className='my-3'>
                                                                    2. {t("selection.chooseOfferLetterResolution")}
                                                                </div>
                                                                <div>
                                                                    <Form.Check
                                                                        type='radio'
                                                                        name='offerLetterStatus'
                                                                        label={t('global.accept')}
                                                                        value={'accept'}
                                                                        onChange={({target}) => setOfferLetterResolution(target.value)}
                                                                        checked={offerLetterResolution === "accept"}
                                                                        className='my-3'
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <Form.Check
                                                                        type='radio'
                                                                        name='offerLetterStatus'
                                                                        label={t('global.reject')}
                                                                        value={'reject'}
                                                                        onChange={({target}) => setOfferLetterResolution(target.value)}
                                                                        checked={offerLetterResolution === "reject"}
                                                                        className='my-3'
                                                                    />
                                                                </div>
                                                                {
                                                                    offerLetterResolution === "reject" &&
                                                                    <div>
                                                                        <Form.Label>{t('selection.offerLetterComment')}</Form.Label>
                                                                        <Form.Control
                                                                            as="textarea"
                                                                            value={offerLetterComment || ''}
                                                                            onChange={({target}) => setOfferLetterComment(target.value)}
                                                                            required
                                                                        />
                                                                    </div>
                                                                }
                                                                <Row className='d-flex justify-content-end my-3'>
                                                                    <Col xs={12} md={4}>
                                                                        <Button type='button' variant='primary' className='mt-3 w-100' onClick={handleSetOfferLetterResolution}>{t('global.save')}</Button>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        :
                                                        
                                                            <div style={{height: "70vh"}}>
                                                                <PDFViewer
                                                                    children={<OfferLetter selection={selection} choose={choose} school={school} />}
                                                                    style={{width: "100%", height: "100%"}}
                                                                />
                                                            </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                activeTab === "incorporationDate" && choose?.candidateStatus !== 2 && !choose?.dimiss && choose?.candidateOfferLetterStatus === 1 && choose?.incorporationDate?.date &&
                                                <div className='my-5 py-3 bg-grey text-center rounded'>
                                                    <img src='/images/success.gif' alt='success' className='mb-3'/>
                                                    <h3 className='fw-bold'>{t("selection.congratulations").toLocaleUpperCase()}</h3>
                                                    <div className='mb-3'>{t("selection.congratulationsText")}</div>
                                                    <h5 className='fw-bold'>{t("selection.submenu.incorporationDate")}</h5>
                                                    <div className='my-3 d-flex justify-content-center'>
                                                        <ul>
                                                            <li>
                                                                {t('profile.candidate.dates')}: {new Date(choose?.incorporationDate?.date).toLocaleDateString('es-ES', {day: '2-digit',month: '2-digit',year: 'numeric',})}
                                                            </li>
                                                            <li>
                                                                {t('dashboard.candidate.hour')}: {choose?.incorporationDate?.hour}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal show={addVideoPresentation} onHide={handleAddVideoModalHide}>
                <Modal.Header closeButton>
                    {t('selection.addVideo')}
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>{t('selection.uploadVideo')}</Form.Label>
                    <Form.Control type='file' accept='.mp4, .mov, .webm' onChange={(e) => {setVideo(e.target.files[0])}} ref={videoFileInput} className='mb-2' />
                    <span className='text-muted'>{t('selection.uploadVideoSubtext')}</span>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' type='button' onClick={handleAddVideoModalHide}>{t('global.cancel')}</Button>
                    <Button variant='primary' type='button' onClick={handleSaveVideo}>{t('global.save')}</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={selectedEvent} onHide={() => {setSelectedEvent(null)}}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedEvent?.selection?.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.school")}
                            <small>{selectedEvent?.school?.name || ''}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("school.selection.datetime")}
                            <small>{selectedEvent?.day ? new Date(selectedEvent?.day).toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric'}) : ''} {selectedEvent?.hour || ''}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.specialty")}
                            <small>{capitalizeFirstCharacter(levels?.find(l => l.id === selectedEvent?.selection?.specialty)?.label)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t(selectedEvent?.selection?.specialty == 1 ? "profile.candidate.position" : "selection.subject")}
                            <small>{t("subjects." + subjects?.find(s => s.id === selectedEvent?.selection?.subject)?.label)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.shortIncorporationDate")}
                            <small>{`${String(new Date(selectedEvent?.selection?.incorporationDate).getDate()).padStart(2, '0')}/${String(new Date(selectedEvent?.selection?.incorporationDate).getMonth() + 1).padStart(2, '0')}/${new Date(selectedEvent?.selection?.incorporationDate).getFullYear()}`}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.salary")}
                            <small>{selectedEvent?.selection?.salary || t("selection.byAgreement")}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.contractType")}
                            <small>
                                {
                                    selectedEvent?.selection.fixedDiscontinuous
                                    ?
                                        t('selection.fixedDiscontinuous')
                                    :
                                        t('profile.candidate.'+ selectedEvent?.selection?.contractType)
                                }
                            </small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("profile.candidate.idealPosition.workDay.label")}
                            <small>{t("profile.candidate.idealPosition.workDay." + selectedEvent?.selection?.workdayType)}</small>
                        </div>
                    </div>
                    {
                        selectedEvent?.school
                        ?
                            <>
                                <div className='py-2 px-3'>
                                    <div className='d-flex justify-content-between'>
                                        {t("users.town")}
                                        <small>{towns?.find(p => p.value === selectedEvent?.school?.town)?.label}</small>
                                    </div>
                                </div>
                                <div className='py-2 px-3 bg-grey'>
                                    <div className='d-flex justify-content-between'>
                                        {t("users.province")}
                                        <small>{provinces?.find(p => p.value === selectedEvent?.school?.province)?.label}</small>
                                    </div>
                                </div>
                                <div className='py-2 px-3'>
                                    <div className='d-flex justify-content-between'>
                                        {t("selection.schoolType")}
                                        <small>{t("school.typeschool." + selectedEvent?.school?.typeschool)}</small>
                                    </div>
                                </div>
                                {
                                    selection?.distance !== null &&
                                    <div className='py-2 px-3'>
                                        <div className='d-flex justify-content-between'>
                                            {t("selection.distance")}
                                            <small>{selection?.distance !== 0 && selection?.distance !== "0" ? `${Math.trunc(Number(selection?.distance))} km` : t("selection.zeroDistance")}</small>
                                        </div>
                                    </div>
                                }
                            </>
                        :
                            <></>
                    }
                </Modal.Body>
            </Modal>
            <Modal className='meeting' show={isMeetingVisible} onHide={() => {setIsMeetingVisible(false)}} fullscreen={true}>
                <Modal.Header closeButton><h4>{t("selection.submenu.interview")}</h4></Modal.Header>
                <Modal.Body>
                    {
                        isMeetingVisible
                        ?
                            <InterviewSection choose={choose} nameSend={client?.firstname+' '+client?.lastname} typeuser={'candidate'} t={t} />
                        :
                            <></>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}